
import Vue from 'vue';
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import FileUploader from "@/components/FileUploader.vue";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import {Route} from "vue-router";
import {Prop} from "vue-property-decorator";
import {CertificateTypeModel, SysAdminCertificateTypesClient, SysAdminCertificateTypeTemplatesClient} from "@/api-client";
import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
import {settings} from "@/main";

@Component({
    components: {
        SectionPageHeading,
        HeadingWave,
        AdministrationDetailviewLayout,
        FileUploader,
        HeadingGroup,
        LabelOptional
    },
    methods: {
        translateTrueFalse
    }
})
export default class AddCertificateType extends Vue {
    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        to.meta!.props.preloadedCertificateType = await new SysAdminCertificateTypesClient().get(to.params.id);
        next();
    }

    @Prop({required: true})
    preloadedCertificateType!: CertificateTypeModel;

    model = this.preloadedCertificateType;
    downloadingTemplate = false;
    templateName: string | null = null;

    async created() {
        // Fetch template name if certificate type has a template
        if (this.model.certificateTypeTemplateId) {
            try {
                const templateClient = new SysAdminCertificateTypeTemplatesClient();
                const template = await templateClient.get(this.model.certificateTypeTemplateId);
                this.templateName = template.name;
            } catch (error) {
                console.error('Failed to fetch template name:', error);
            }
        }
    }

    async downloadTemplate() {
        if (!this.model.certificateTypeTemplateId || !this.model.id) {
            return;
        }

        this.downloadingTemplate = true;
        try {
            // Use the certificate type's download endpoint which will use custom text literals if available
            const downloadUrl = `${settings.misApiBaseUrl}/api/certificate-types/${this.model.id}/download-template?t=${Date.now()}`;
            window.open(downloadUrl, '_blank');
        } catch (error) {
            console.error('Failed to download template:', error);
        } finally {
            this.downloadingTemplate = false;
        }
    }
}
